import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";
import ModalCreateAddress from "../../ModalCreateAddress";

export const SelectAddress = ({type, customerId, companyId, addressId, setAddressId}) => {
    const [loading, setLoading] = useState(true);

    const labels = {
        shipping: 'Endereço de entrega',
        billing: 'Endereço de cobrança'
    };

    const [showCreateCompanyAddress, setShowCreateCompanyAddress]= useState(false);
    const [gettingAddresses, setGettingAddresses] = useState(true);
    const [addresses, setAddresses] = useState([]);

    useEffect(() => {
        getAddresses();
    }, [companyId, companyId]);
    
    const getAddresses = async () => {
        if (!companyId && !customerId) {
            setAddresses([]);
            setGettingAddresses(false);
            return;
        }
    
        setGettingAddresses(true);
    
        try {
            const entityId = companyId || customerId;
            const entityName = companyId ? 'company' : 'customer';
    
            const res = await api.get(`/${entityName}/${entityId}/address?type=${type}`);
            setAddresses(res.data.resources);
        } catch (error) {
            console.error('Erro ao buscar endereços:', error);
            setAddresses([]);
        } finally {
            setGettingAddresses(false);
        }
    };

    const addAddress = address => {
        setAddresses(prev => [...prev, address]);
        setAddressId(address.id);
    }

    return (
        <>
            <ModalCreateAddress
                show={showCreateCompanyAddress}
                close={() => setShowCreateCompanyAddress(false)}
                onAddressStored={addAddress}
                companyId={companyId}
                customerId={customerId}
                type={type}
            />
            <InputSelect 
                label={labels[type]} 
                options={createOptions(addresses, 'formatted_address', 'id', true, null, 'Selecione...')} 
                value={addressId}
                change={setAddressId}
            />
            <a 
                href="#" 
                className="link-pos-input"
                onClick={e => {
                    e.preventDefault();
                    setShowCreateCompanyAddress(true);
                }}
            >
                Cadastrar novo endereço
            </a>
        </>
    );
}

export default SelectAddress;